<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path
      d="M12 11C10.4 9 7.2 9 6 11.5C4.8 14 7.2 16 12 19C16.8 16 19.2 14 18 11.5C16.8 9 13.6 9 12 11Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="M22 17C20.4 15 17.2 15 16 17.5C14.8 20 17.2 22 22 25C26.8 22 29.2 20 28 17.5C26.8 15 23.6 15 22 17Z"
      fill="currentColor"
      fill-opacity=".5"
      stroke="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconIntentRelationship',
  props: { size: { type: [String, Number], default: 22 } },
};
</script>
